import { render, staticRenderFns } from "./CaseDetail.vue?vue&type=template&id=1cf6a686&scoped=true&"
import script from "./CaseDetail.vue?vue&type=script&lang=js&"
export * from "./CaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./CaseDetail.vue?vue&type=style&index=0&id=1cf6a686&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf6a686",
  null
  
)

export default component.exports